import { Link } from "react-router-dom";
import { Route } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ScenarioRowProps } from "./scenario-row-types";

export function ScenarioVariantPill({
  scenario,
  effectiveHref,
  onSelect,
  badge,
  trailing,
  className,
}: Pick<
  ScenarioRowProps,
  "scenario" | "onSelect" | "badge" | "trailing" | "className"
> & {
  effectiveHref: string | null;
}) {
  return (
    <div
      className={cn(
        "group inline-flex max-w-full items-center justify-between gap-2 rounded-md border border-border/60 bg-muted/20 px-2.5 py-1 text-xs transition-colors hover:border-border hover:bg-muted/40",
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-1.5">
        {effectiveHref ? (
          <Link
            to={effectiveHref}
            onClick={(e) => {
              if (
                onSelect &&
                !e.metaKey &&
                !e.ctrlKey &&
                !e.shiftKey &&
                !e.altKey &&
                e.button === 0
              ) {
                e.preventDefault();
                onSelect(scenario.id);
              }
            }}
            className="flex min-w-0 items-center gap-1.5 truncate font-medium text-foreground hover:underline"
            title={scenario.name}
          >
            <Route
              className="size-3 shrink-0 text-muted-foreground"
              aria-hidden="true"
            />
            <span className="truncate">{scenario.name}</span>
          </Link>
        ) : onSelect ? (
          <button
            type="button"
            onClick={() => onSelect(scenario.id)}
            className="flex min-w-0 items-center gap-1.5 truncate text-left font-medium text-foreground hover:underline cursor-pointer"
            title={scenario.name}
          >
            <Route
              className="size-3 shrink-0 text-muted-foreground"
              aria-hidden="true"
            />
            <span className="truncate">{scenario.name}</span>
          </button>
        ) : (
          <div className="flex min-w-0 items-center gap-1.5">
            <Route
              className="size-3 shrink-0 text-muted-foreground"
              aria-hidden="true"
            />
            <span
              className="truncate font-medium text-foreground"
              title={scenario.name}
            >
              {scenario.name}
            </span>
          </div>
        )}
      </div>
      {badge && <div className="shrink-0">{badge}</div>}
      {trailing && <div className="shrink-0">{trailing}</div>}
    </div>
  );
}
